const includeViewOptions = (view?: string, isViewOptionsClicked?: boolean) =>
  view && (isViewOptionsClicked || view === 'gallery-view');

export default includeViewOptions;
